import webAPIRequestPGIS from "@/plugin/gis-viewer/widgets/WebAPI/pgis/webAPIRequest";
import OverlayPGIS from "@/plugin/gis-viewer/widgets/Overlays/pgis/OverlayPGIS";
import rebObj from "../picUrlBase64";
import {
  IGeocode,
  IResult,
  IJurisdiction,
  IReverseGeocode,
  IPOIDelete,
  IPOISearchPGIS,
  IMultiBoundary, IBoundary
} from '@/types/map';

export default class POISearchPGIS {
  private view: any;
  private fmap: any;
  private static instances: Map<string, any>;
  private xzoptions: Array<{ value: string; label: string; node: string }> = [
    {
      value: "凉山彝族自治州",
      label: "凉山",
      node: "513400000000"
    },
    {
      value: "西昌市",
      label: "西昌",
      node: "513401000000"
    },
    {
      value: "雷波县",
      label: "雷波",
      node: "513437000000"
    },
    {
      value: "美姑县",
      label: "美姑",
      node: "513436000000"
    },
    {
      value: "甘洛县",
      label: "甘洛",
      node: "513435000000"
    },
    {
      value: "越西县",
      label: "越西",
      node: "513434000000"
    },
    {
      value: "冕宁县",
      label: "冕宁",
      node: "513433000000"
    },
    {
      value: "喜德县",
      label: "喜德",
      node: "513432000000"
    },
    {
      value: "昭觉县",
      label: "昭觉",
      node: "513431000000"
    },
    {
      value: "金阳县",
      label: "金阳",
      node: "513430000000"
    },
    {
      value: "布拖县",
      label: "布拖",
      node: "513429000000"
    },
    {
      value: "普格县",
      label: "普格",
      node: "513428000000"
    },
    {
      value: "宁南县",
      label: "宁南",
      node: "513427000000"
    },
    {
      value: "会东县",
      label: "会东",
      node: "513426000000"
    },
    {
      value: "会理县",
      label: "会理",
      node: "513425000000"
    },
    {
      value: "德昌县",
      label: "德昌",
      node: "513424000000"
    },
    {
      value: "盐源县",
      label: "盐源",
      node: "513423000000"
    },
    {
      value: "木里藏族自治县",
      label: "木里",
      node: "513422000000"
    }
  ];

  private constructor(view: any, fmap: any) {
    this.view = view;
    this.fmap = fmap;
  }

  public static getInstance(view: any, fmap: any) {
    let id = view.getTarget();
    if (!POISearchPGIS.instances) {
      POISearchPGIS.instances = new Map();
    }
    let instance = POISearchPGIS.instances.get(id);
    if (!instance) {
      instance = new POISearchPGIS(view, fmap);
      POISearchPGIS.instances.set(id, instance);
    }
    return instance;
  }

  public async searchPOI(params: IPOISearchPGIS): Promise<IResult> {
    //搜索兴趣点图层
    const searchLayers = params.searchLayer;
    const orgCode = params.orgCode || 513400000000;
    const keyWords = params.searchName || '';
    const searchPage = params.searchPage || 0;
    const searchSize = params.searchSize || 20;
    const searchShapeType = params.searchType || '';
    const searchCoords = params.searchCoords || '';

    const requestResults = await webAPIRequestPGIS.requestPOI({
      searchLayer: searchLayers,
      searchName: keyWords,
      orgCode: orgCode,
      searchPage: searchPage,
      searchSize: searchSize,
      searchType: searchShapeType,
      searchCoords: searchCoords
    });

    console.log(requestResults);
    return {
      status: 0,
      message: '成功调用searchPOI方法!'
    }
  }

  public async clearPOIResults(params: IPOIDelete): Promise<IResult> {
    return {
      status: 0,
      message: '成功调用clearPOIResults!'
    }
  }

  public async searchJurisdiction(params: IJurisdiction): Promise<IResult> {
    const orgCode = params.orgCode;

    const requestResults = await webAPIRequestPGIS.requestJurisdictionBoundary({
      orgCode: orgCode,
    })
    return {
      status: 0,
      message: '成功调用searchJurisdiction方法!'
    }
  }

  public async searchBoundary(params: IBoundary): Promise<IResult> {
    const name = params.searchName;
    const color = params.color || "rgba(0,0,255,0.4)";
    const outline = params.outline;
    const lineColor = outline ? outline.color : "rgb(255,0,0)";
    const lineWidth = outline ? outline.width : 1;
    const contains = params.contains === true;
    const centerResult = params.centerResult !== false;
    let overlays: any[] = [];

    let findRes: any = this.xzoptions.find((item) => {
      if (item.label == name.substr(0, 2)) {
        return true;
      }
    })

    if (contains && findRes && name.substr(0, 2) == "凉山") {
      const requestResults = await webAPIRequestPGIS.requestSubJurisdiction({
        orgCode: findRes.node,
      })
      let results = requestResults.rows;
      for (let single of results) {
        let findRes: any;
        if (name.substr(0, 2) == "凉山") {
          //凉山州只显示区县的
          findRes = this.xzoptions.find((item) => {
            if (item.node == single.code) {
              return true;
            }
          })
        }
        else {
          findRes = single;
        }

        if (findRes) {
          let overlay = await this.drawArea(single.code, single.name);
          if (overlay) {
            overlays.push(overlay);
          }
        }
      }
      if (centerResult) {
        this.fmap.setMapLocation({
          center: [101.9673705, 27.6764495],  //地图中心点坐标，如果有z值，则zoom值无效
          zoom: 8,   //地图缩放级别，默认13（非必须）
        })
      }
    }
    else {
      let overlay = await this.drawArea(findRes.node, findRes.value);
      overlays.push(overlay);
    }
    let over = OverlayPGIS.getInstance(this.view, this.fmap)
    await over.addOverlays({
      type: "simplePolygon",
      defaultSymbol: {
        type: "polygon",
        color: color,
        outline: {
          color: lineColor,
          width: lineWidth
        }
      },
      centerResult: centerResult,
      overlays: overlays
    })
    return {
      status: 0,
      message: '成功调用searchJurisdiction方法!'
    }
  }
  public async drawArea(code: string, name: string): Promise<any> {
    const requestResults = await webAPIRequestPGIS.requestJurisdictionBoundary({
      orgCode: Number(code)
    })
    if (requestResults.rows.length > 0 && requestResults.rows[0].bounds) {
      let bounds = requestResults.rows[0].bounds;
      let boundsArr = bounds.split(",");
      let paths = [];
      for (let i = 0; i < boundsArr.length - 1; i += 2) {
        paths.push([Number(boundsArr[i]), Number(boundsArr[i + 1])]);
      }
      return {
        id: code,
        geometry: { rings: paths },
        fields: { name: name, featureid: code }
      };
    }
    return undefined
  }

  public async searchMultiIJurisdiction(params: IMultiBoundary): Promise<IResult> {
    return {
      status: 0,
      message: '成功调用searchMultiIJurisdiction方法!'
    }
  }


}